import { contactInfo } from '../mock';

export const DEFAULT_WHATSAPP_MESSAGE = 'Merhaba, projeniz hakkinda bilgi almak istiyorum.';
export const WHATSAPP_REPLIES = [
  'Teklif almak istiyorum', 'Asma germe sistemleri hakkinda bilgi',
  'Depo cadiri fiyat bilgisi', 'Calisma saatleri nedir?',
];

export const formatWhatsAppUrl = (phone, message = DEFAULT_WHATSAPP_MESSAGE) =>
  `https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;

export const sendWhatsApp = (message) => {
  window.open(formatWhatsAppUrl(contactInfo.phone, message), '_blank', 'noopener,noreferrer');
};